import { useMediaQuery } from "react-responsive";
import { useState } from 'react';
import { useAccount } from '../../hooks/useAccount';
import { MainCard, YieldCard, WalletCard, MintedCard, TimerCard, SideBar, DepositCard } from '../organisms';

const Home = (props: any) => {
  const isTabletOrMobile = useMediaQuery({ maxWidth: 1220 });

  return (
    <div className='home'>
      {isTabletOrMobile && (
        <SideBar pageWrapId={"page-wrap"} outerContainerId={"home"} />
      )}
      <WalletCard />
      <div className='yield-title'>
        <h1>
          {props.nameToken} Yield
        </h1>
      </div>
      <div id='page-wrap' className='top-container'>
        {/* <BuyCard nameToken={props.nameToken} /> */}
        <MintedCard nameToken={props.nameToken} />
        <TimerCard nameToken={props.nameToken} />
        <YieldCard nameToken={props.nameToken} />
      </div>
      <div className='body-container'>
        <DepositCard nameToken={props.nameToken} />
        <MainCard nameToken={props.nameToken} />
      </div>
    </div>

  );
};

export default Home;
